var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"df8125e5816abe0d2ee35351155c34bff6bff8c6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["account@superhi"]={id:"df8125e5816abe0d2ee35351155c34bff6bff8c6"};
      